import { render, staticRenderFns } from "./ComplainceRulesNew.vue?vue&type=template&id=015f9c99&scoped=true"
import script from "./ComplainceRulesNew.vue?vue&type=script&lang=js"
export * from "./ComplainceRulesNew.vue?vue&type=script&lang=js"
import style0 from "./ComplainceRulesNew.vue?vue&type=style&index=0&id=015f9c99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015f9c99",
  null
  
)

export default component.exports